import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrderPreviewTablesModule} from '../order-preview/order-preview-tables.module';
import {DevExtremeModule} from '../devextreme.module';
import {EtsCommonModule} from '../common-services/common.module';
import {PhaExportDialogComponent} from './pha-export-dialog.component';

// The Export window as its own module (CR-20260930-001 M3): the Analysis panel uses it to export, the
// Portfolio Hedging (Collars) panel uses the SAME window in its acquire mode (owner 2026-09-30: the
// acquisition window looks like the export window, plus a fill box per leg and an Acquire button).
// Stateless — no providers.
@NgModule({
    imports: [
        OrderPreviewTablesModule,
        CommonModule,
        DevExtremeModule,
        // The 'etsFriendlyDatePipe' the After State tables use.
        EtsCommonModule
    ],
    declarations: [PhaExportDialogComponent],
    exports: [PhaExportDialogComponent]
})
export class PhaExportDialogModule {
}
